import _omit from "lodash/omit";
import PropTypes from "prop-types";
import React from "react";
import Button from "../Button";
import { Field, PasswordField } from "../forms";

import userIcon from "../../assets/svg/icon-user.svg";
import styles from "../../styles/components/MyAccount.css";

import { isValidEmail } from "../../modules/user/utils";
import { userActions } from "../../modules/user";

export default class MyProfileForm extends React.PureComponent {
    static propTypes = {
        user: PropTypes.shape({
            id: PropTypes.number.isRequired,
            firstName: PropTypes.string.isRequired,
            lastName: PropTypes.string.isRequired,
            emailAddress: PropTypes.string.isRequired,
            title: PropTypes.string
        }).isRequired,
        updateProfile: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this.handleTextChange = this.handleTextChange.bind(this);

        const { user } = this.props;

        this.state = {
            firstName: user.firstName,
            lastName: user.lastName,
            emailAddress: user.emailAddress,
            password: "",
            title: user.title ? user.title : "",
            confirmEmailAddress: "",
            confirmPassword: ""
        };
    }

    handleTextChange(event) {
        const value =
            event.target.name === "emailAddress" ||
            event.target.name === "confirmEmailAddress"
                ? event.target.value.trim()
                : event.target.value;
        this.setState({
            [event.target.name]: value
        });
    }

    handleSaveChanges(event) {
        event.preventDefault();

        const omitPassword =
            this.state.password === ""
                ? ["confirmEmailAddress", "confirmPassword", "password"]
                : ["confirmEmailAddress", "confirmPassword"];
        const omitEmail =
            this.state.emailAddress === this.props.user.emailAddress
                ? ["emailAddress"]
                : [];

        const properties = _omit(this.state, omitPassword, omitEmail);

        this.props
            .updateProfile(this.props.user.id, properties)
            .then(action => {
                if (action.type === userActions.UPDATE_USER_SUCCESS) {
                    this.setState({
                        password: "",
                        confirmEmailAddress: "",
                        confirmPassword: ""
                    });
                    return this.props.notifySuccess(
                        "Your account has been updated.",
                        "check-circle"
                    );
                }
            });
    }

    renderCondition = () => {
        const {
            firstName,
            lastName,
            emailAddress,
            password,
            confirmEmailAddress,
            confirmPassword
        } = this.state;
        const { user } = this.props;

        const isEmailValid = isValidEmail(emailAddress);
        const isEqualEmail = emailAddress === confirmEmailAddress;
        const isEqualPass = password === confirmPassword;
        const showConfirmEmail = emailAddress !== user.emailAddress;

        const showConfirmPassword = password.length > 0;
        const isPasswordValid = password.length >= 8 || password === "";

        const isNameValid = firstName !== "" && lastName !== "";
        const enabled =
            isNameValid &&
            isEmailValid &&
            (!showConfirmEmail || isEqualEmail) &&
            isPasswordValid &&
            (!showConfirmPassword || isEqualPass);

        return {
            disabled: !enabled,
            isEmailValid,
            isPasswordValid,
            isEqualEmail,
            isEqualPass,
            showConfirmEmail,
            showConfirmPassword
        };
    };

    render() {
        const contactUsEmail = "support@wevoconversion.com";
        const {
            disabled,
            isEmailValid,
            isPasswordValid,
            isEqualEmail,
            isEqualPass,
            showConfirmEmail,
            showConfirmPassword
        } = this.renderCondition();

        return (
            <div>
                <form className={styles.profileForm}>
                    <h1 className={styles.formHeader}>My Profile</h1>

                    <div>
                        <div className={styles.profileIcon}>
                            <img
                                className={styles.innerProfileIcon}
                                src={userIcon}
                            />
                        </div>
                    </div>

                    <div className={styles.formRow}>
                        <Field
                            id="my-profile-first-name"
                            name="firstName"
                            placeholder="First Name"
                            onChange={this.handleTextChange}
                            value={this.state.firstName}
                            isValid={this.state.firstName !== ""}
                            message={
                                this.state.firstName !== ""
                                    ? null
                                    : "First Name can not be empty."
                            }
                        />
                        <Field
                            id="my-profile-last-name"
                            name="lastName"
                            placeholder="Last Name"
                            onChange={this.handleTextChange}
                            value={this.state.lastName}
                            isValid={this.state.lastName !== ""}
                            message={
                                this.state.lastName !== ""
                                    ? null
                                    : "Last Name can not be empty."
                            }
                        />
                    </div>

                    <div className={styles.formRow}>
                        <Field
                            id="my-profile-title"
                            name="title"
                            placeholder="Title"
                            onChange={this.handleTextChange}
                            value={this.state.title}
                        />
                    </div>

                    <div className={styles.formRow}>
                        <Field
                            id="my-profile-email-address"
                            name="emailAddress"
                            placeholder="email@domain.com"
                            onChange={this.handleTextChange}
                            value={this.state.emailAddress}
                            isValid={isEmailValid}
                            message={
                                isEmailValid ? null : "Email should be valid."
                            }
                        />
                    </div>

                    {showConfirmEmail ? (
                        <div className={styles.formRow}>
                            <Field
                                id="my-profile-confirm-email-address"
                                name="confirmEmailAddress"
                                placeholder="Confirm Email"
                                onChange={this.handleTextChange}
                                value={this.state.confirmEmailAddress}
                                isValid={isEqualEmail}
                                message={
                                    isEqualEmail
                                        ? null
                                        : "Confirm email should be same."
                                }
                            />
                        </div>
                    ) : null}

                    <div className={`${styles.formRow}`}>
                        <PasswordField
                            isValid={isPasswordValid}
                            message={
                                isPasswordValid
                                    ? null
                                    : "Passwords must be a minimum of 8 characters long."
                            }
                            id="my-profile-change-password"
                            name="password"
                            placeholder="Change Password"
                            onChange={this.handleTextChange}
                            value={this.state.password}
                        />
                    </div>

                    {showConfirmPassword ? (
                        <div className={styles.formRow}>
                            <PasswordField
                                isValid={isEqualPass}
                                message={
                                    isEqualPass
                                        ? null
                                        : "Confirm Password should be same as password."
                                }
                                id="my-profile-confirm-change-password"
                                name="confirmPassword"
                                placeholder="Confirm Password"
                                onChange={this.handleTextChange}
                                value={this.state.confirmPassword}
                            />
                        </div>
                    ) : null}

                    <Button
                        onClick={this.handleSaveChanges.bind(this)}
                        disabled={disabled}
                    >
                        Update Profile
                    </Button>
                </form>

                <div className={styles.contactUs}>
                    <p>
                        To request changes to your company or team name, please
                        email us at{" "}
                        <a href={`mailto:${contactUsEmail}`}>
                            {contactUsEmail}
                        </a>
                        , or call +1 (888) 835-6828.
                    </p>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/MyAccount/MyProfileForm.js